import {
    RxJsonSchema
} from 'rxdb';
import { Path } from '../models/path';


export const pathSchema: RxJsonSchema<Path> = {
    title: 'path schema',
    version: 1,
    keyCompression: false,
    type: 'object',
    properties: {
        id: {
            type: 'string',
            primary: true
        },
        buildingId: {
            type: 'string'
        },
        description: {
            type: ['string', 'null']
        },
        updatedAt: { 
            type: 'number' 
        }
    },
    required: ['id', 'buildingId' ],
    indexes: [ 'id', 'buildingId', 'updatedAt']
};

export const pathPullQueryBuilder = () => {
    return (doc) => {
        if (!doc) {
            doc = {
                id: '',
                buildingId:'',
                description:'',
                updatedAt:0
            };
        }
        const query = `{
            feedForRxdbPaths(lastId: "${doc.id}", minUpdatedAt: ${doc.updatedAt} ) {
                id
                buildingId
                description
                updatedAt
                deleted
                _rev
            }
        }`;

        return {
            query,
            variables: {}
        };
    }
};